import { render, staticRenderFns } from "./ListSubscriptions.vue?vue&type=template&id=0f47d960&"
import script from "./ListSubscriptions.vue?vue&type=script&lang=js&"
export * from "./ListSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./ListSubscriptions.vue?vue&type=style&index=0&id=0f47d960&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports